import { Deserializable } from '../deserializable';
import { NamedEntityDto } from './named-entity-dto';

export class AdvisedArtefactDto implements Deserializable {
  ApplicationID: string;
  ApplicationNumber?: number;
  ApplicationTypeCode: string;
  LastModifiedDate?: Date;
  ModifiedBy: string;
  CompanyName: string;
  CaseOwner: string;
  CaseOwnerID?: number;
  CaseOwnerIDHash: string;
  TeamCode: string;
  AdviceOwner: string;
  AdviceOwnerID?: number;
  AdviceOwnerIDHash: string;
  AdviceTeamCode: string;
  CaseType: string;
  StatusCode: string;
  CaseStatusCode: string;
  IsForAdvice: boolean;
  PropositionLogoPath: string;
  IsAutoPackagingEnabled: boolean;
  IsQualifiedForPackaging?: boolean;
  IsDataCompleted?: boolean;
  SuitabilityReportID?: number;
  SuitabilityReportIDHash: string;
  LoanGroupTypeCode: string;
  IsDownloadedToSAM: boolean;
  OriginatorId: string;
  OriginatorName: string;
  OriginatorDetails: string;
  OriginatorUserName: string;
  OriginatorCompanyDetails: string;
  InterfaceTypeId: number;
  PropositionId: number;
  BranchUserId: string;
  CaseAdministratorsNames: Array<NamedEntityDto>;
  IsAipCertificateAvailable: boolean;
  WasPackagingPublished?: boolean;
  SubmittedDate?: Date;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
